import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { withStyles } from '@material-ui/core/styles';
import appContent from 'aurora-api/dummy/appContent';
import { FormattedMessage } from 'react-intl';
import messages from 'aurora-translations';
import Typography from '@material-ui/core/Typography';
import { keyEmptyCheck } from 'aurora-utils/utils';
import Link from '@material-ui/core/Link';
import Hidden from '@material-ui/core/Hidden';
import Box from '@material-ui/core/Box';
import { useClipboard } from 'aurora-hooks';

import { ADGMBreadcrumbs, ADGMImage } from 'aurora-components';

import styles from './styleJss';
import './applicationDetail.css';

function ApplicationDetailLayout(props) {
  const { classes, children, breadCrumbs, id, type } = props;
  const title = appContent.name + ' - Application Detail';
  const description = appContent.desc;
  const { copy } = useClipboard();
  return (
    <div className={classes.main}>
      <div className={classes.container}>
        <Helmet>
          <title>{title}</title>
          <meta name='description' content={description} />
          <meta property='og:title' content={title} />
          <meta property='og:description' content={description} />
          <meta property='twitter:title' content={title} />
          <meta property='twitter:description' content={description} />
        </Helmet>
        <Hidden smDown>
          <div className={classes.breadcrumbsHolder}>
            <ADGMBreadcrumbs paths={breadCrumbs} />

            <Typography className={classes.serviceid}>
              <FormattedMessage {...messages.Application_ID} />: {id}
            </Typography>
          </div>
        </Hidden>
        <Hidden mdUp>
          <div className={classes.mobiletitlehead}>
            <Link href='/app/applications'>
              <ADGMImage name='BackClose.svg' alt='BackClose' className='mobilebackarrow' aria-hidden='true' />
            </Link>
            <Typography variant='h6' component='h2'>
              {keyEmptyCheck(type)}
            </Typography>
          </div>

          <Box className={classes.grayBox}>
            <div className={classes.gratTextColor}>
              <Typography variant='body1'>
                {keyEmptyCheck('Application_ID')}:{' '}
                <span className={classes.fontWeight600}>
                  {id}
                  <ADGMImage
                    onClick={() => copy(id)}
                    className={classes.copyRightEvent}
                    name='ApplicationIDicon.svg'
                    alt='ApplicationIDicon'
                  />
                </span>
              </Typography>
            </div>
          </Box>
        </Hidden>
        {children}
      </div>
    </div>
  );
}

ApplicationDetailLayout.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  breadCrumbs: PropTypes.array.isRequired,
  id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};

export default withStyles(styles)(ApplicationDetailLayout);
